<template>
    <div>
        <div class="w-full md:w-4/5 m-auto py-6 px-0 md:px-12">
            <div v-if="!loading" class="lds-spinner">
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
                <div />
            </div>
            <h1 class="mb-4 text-green-600 text-2xl text-left font-bold text-2xl">
                <router-link :to="{ name: 'ViewApplication' }">Applications</router-link>
                / {{ personalData.first_name }} {{ personalData.last_name }}
            </h1>
            <div class="bg-white bg-gray-100 border p-8 mt-1 pb-6">
              <div class="text-start text-sm" v-html="applicationData?.module?.data?.guidance">
              </div>
              <div v-if="applicationData?.module?.data?.guidance" class="border-2 border-secondary"/>
                <div class="flex justify-between mb-6 px-8 mt-4 align-baseline text-sm">
                    <div v-if="loading" class="w-full flex flex-col items-center">
                        <table class="table-auto text-left">
                            <tr>
                                <th class="text-right pr-4">Applicant:</th>
                                <td class="pr-8">{{ personalData.first_name }} {{ personalData.last_name }}</td>
                                <th class="text-right pr-4">Academic year:</th>
                                <td class="pr-8">{{ applicationData?.academicYear }}</td>
                            </tr>
                            <tr>
                                <th class="text-right pr-4">Programme type:</th>
                                <td class="pr-8">{{ applicationData?.programmeType }}</td>
                                <th class="text-right pr-4">Study mode:</th>
                                <td class="">{{ applicationData?.study_mode_title }}</td>
                            </tr>
                            <tr>
                                <th class="text-right pr-4">Programme:</th>
                                <td class="pr-8">{{ applicationData?.programmeName }}</td>
                                <th class="text-right pr-4">Status:</th>
                                <td class="">
                                    <span>{{ applicationData.public_status }}</span>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
              <div v-if="applicationData.hasDocumentRequest">
                <document-request-response-form :document-requests="applicationData?.documentRequests?.data"/>
              </div>
              <div id="programme_details" class="bg-white border border-gray-300 cursor-pointer hover:bg-gray-200 flex justify-between px-8 mt-1"
                   @click="programmeDetailsShow = !programmeDetailsShow"
              >
                <h1 class="text-1xl leading-10">Programme Details</h1>
                <icon :name="!programmeDetailsShow ? 'cheveron-right' : 'cheveron-down'"
                      class="fill-current w-7 h-10 ml-2"
                />
              </div>
              <div id="programme_details_content" :class="{ hide: !programmeDetailsShow }" class="bg-white border border-t-0 border-gray-300 overflow-hidden">
                <programme-details v-if="loading"
                                   :programme-type="applicationData?.programme_code"
                                   :application-data="applicationDetails"
                                   :application-ref="$route.params.id"
                                   :mode-of-attendance="modeOfAttendance"
                                   :programme-data="programmeData.data"
                                   :programme-types-list="programmeTypesList"
                                   :programmes="programmesList['data']"
                                   :proposed-start-dates="proposedStartDates"
                                   :courses="coursesList?.data"
                                   @programmeChange="programmeChange"
                                   @typeChanged="programmeTypeChange"
                />
              </div>
              <div id="personal_details" class="bg-white border border-gray-300 cursor-pointer hover:bg-gray-200 flex justify-between px-8 mt-1"
                     @click="personalDetailsShow = !personalDetailsShow"
                >
                    <!-- <icon :name="!personalData.reference ? 'cross-icon' : 'tick-icon'" class="absolute top-3 left-0 fill-current w-4 h-4 ml-2" /> -->
                    <h1 class="text-1xl leading-10">Personal Details</h1>
                    <icon :name="!personalDetailsShow ? 'cheveron-right' : 'cheveron-down'"
                          class="fill-current w-7 h-10 ml-2"
                    />
                </div>
                <div id="personal_details_content" :class="{ hide: !personalDetailsShow }"
                     class="bg-white border border-t-0 border-gray-300 overflow-hidden"
                >
                    <div>
                        <personal-details v-if="loading"
                                          :application-data="applicationDetails"
                                          :countries-of-birth-list="countriesOfBirthList"
                                          :countries-of-domicile-list="countriesOfDomicileList"
                                          :genders="genders"
                                          :personal-data="personalData"
                                          :reference="$route.params.id"
                                          :titles-list="titlesList"
                        />
                    </div>
                </div>

                <div id="nationality" class="bg-white border border-gray-300 cursor-pointer hover:bg-gray-200 flex justify-between px-8 mt-1"
                     @click="nationalityShow = !nationalityShow"
                >
                    <h1 class="text-1xl leading-10">Nationality</h1>
                    <icon :name="!nationalityShow ? 'cheveron-right' : 'cheveron-down'"
                          class="fill-current w-7 h-10 ml-2"
                    />
                </div>
                <div id="nationality_content" :class="{ hide: !nationalityShow }"
                     class="bg-white border border-t-0 border-gray-300 overflow-hidden"
                >
                    <div>
                        <nationality v-if="loading"
                                     :application-data="applicationDetails"
                                     :countries-of-birth-list="countriesOfBirthList"
                                     :countries-of-domicile-list="countriesOfDomicileList"
                                     :genders="genders"
                                     :nationality="nationality"
                                     :personal-data="personalData"
                                     :reference="$route.params.id"
                                     :titles-list="titlesList"
                        />
                    </div>
                </div>

                <div id="contact_details" class="bg-white border border-gray-300 cursor-pointer hover:bg-gray-200 flex justify-between px-8 mt-1"
                     @click="contactDetailsShow = !contactDetailsShow"
                >
                    <h1 class="text-1xl leading-10">Contact Details</h1>
                    <icon :name="!contactDetailsShow ? 'cheveron-right' : 'cheveron-down'"
                          class="fill-current w-7 h-10 ml-2"
                    />
                </div>
                <div id="contact_details_content" :class="{ hide: !contactDetailsShow }"
                     class="bg-white border border-t-0 border-gray-300 overflow-hidden"
                >
                    <contact-details v-if="loading"
                                     :application-reference="$route.params.id"
                                     :contact-data="contactData"
                                     :contact-detail-types-list="contactDetailTypesList"
                                     :countries-of-domicile-list="countriesOfDomicileList"
                                     :country-of-domicile-id="applicationDetails.data.country_of_domicile_id"
                    />
                </div>
                <div id="education_details" class="bg-white border border-gray-300 cursor-pointer hover:bg-gray-200 flex justify-between px-8 mt-1"
                     @click="educationDetailsShow = !educationDetailsShow"
                >
                    <h1 class="text-1xl leading-10">Education</h1>
                    <icon :name="!educationDetailsShow ? 'cheveron-right' : 'cheveron-down'"
                          class="fill-current w-7 h-10 ml-2"
                    />
                </div>
                <div id="education_details_content" :class="{ hide: !educationDetailsShow }"
                     class="bg-white border border-t-0 border-gray-300 overflow-hidden flex flex-wrap"
                >
                    <education-details v-if="loading"
                                       :application-reference="$route.params.id"
                                       :countries-of-domicile-list="countriesOfDomicileList"
                                       :prior-education="priorEducation"
                    />
                </div>


                <div id="employment_details" class="bg-white border border-gray-300 cursor-pointer hover:bg-gray-200 flex justify-between px-8 mt-1"
                     @click="employmentDetailsShow = !employmentDetailsShow"
                >
                    <h1 class="text-1xl leading-10">Employment</h1>
                    <icon :name="!employmentDetailsShow ? 'cheveron-right' : 'cheveron-down'"
                          class="fill-current w-7 h-10 ml-2"
                    />
                </div>
                <div id="employment_details_content" :class="{ hide: !employmentDetailsShow }"
                     class="bg-white border border-t-0 border-gray-300 overflow-hidden flex flex-wrap"
                >
                    <employment-details v-if="loading"
                                        :application-data="applicationDetails"
                                        :application-reference="$route.params.id"
                                        :countries-of-domicile-list="countriesOfDomicileList"
                                        :employment-data="employmentHistory"
                                        class="w-full"
                    />
                </div>

                <div v-if="requireWorkExperienceOrMaths" id="work_experience_details" class="bg-white border border-gray-300 cursor-pointer hover:bg-gray-200 flex justify-between px-8 mt-1"
                     @click="workExperienceShow = !workExperienceShow"
                >
                    <h1 class="text-1xl leading-10">Programme specific work experience and/or essential maths skills</h1>
                    <icon :name="!workExperienceShow ? 'cheveron-right' : 'cheveron-down'"
                          class="fill-current w-7 h-10 ml-2"
                    />
                </div>
                <div v-if="requireWorkExperienceOrMaths" id="work_experience_details_content" :class="{ hide: !workExperienceShow }"
                     class="bg-white border border-t-0 border-gray-300 overflow-hidden flex flex-wrap"
                >
                    <work-experience-and-mathematics-details v-if="loading"
                                        :application-data="applicationData"
                                        :application-ref="$route.params.id"
                                        :programme-data="programmeData.data"
                                        class="w-full"
                    />
                </div>

                <div v-if="firstChoiceType !== undefined && firstChoiceType['num_references_required'] > 0">
                    <div id="references" class="bg-white border border-gray-300 cursor-pointer hover:bg-gray-200 flex justify-between px-8 mt-1"
                         @click="referencesShow = !referencesShow"
                    >
                        <h1 class="text-1xl leading-10">Referees</h1>
                        <icon :name="!referencesShow ? 'cheveron-right' : 'cheveron-down'"
                              class="fill-current w-7 h-10 ml-2"
                        />
                    </div>
                    <div id="references_content" :class="{ hide: !referencesShow }"
                         class="bg-white border border-t-0 border-gray-300 overflow-hidden flex flex-wrap"
                    >
                        <referees v-if="loading"
                                  :applicant-email="personalData?.email"
                                  :application-reference="$route.params.id"
                                  :countries-of-domicile-list="countriesOfDomicileList"
                                  :programme-choice-type="firstChoiceType"
                                  :referee-data="applicationData['referees']['data']"
                                  :titles-list="titlesList"
                                  @refreshApplication="loadApplication"
                        />
                    </div>
                </div>

                <div id="personal_statement" class="bg-white border border-gray-300 cursor-pointer hover:bg-gray-200 flex justify-between px-8 mt-1"
                     @click="statementShow = !statementShow"
                >
                    <h1 class="text-1xl leading-10">Personal Statement</h1>
                    <icon :name="!statementShow ? 'cheveron-right' : 'cheveron-down'"
                          class="fill-current w-7 h-10 ml-2"
                    />
                </div>
                <div id="personal_statement_content" :class="{ hide: !statementShow }"
                     class="bg-white border border-t-0 border-gray-300 overflow-hidden flex flex-wrap"
                >
                    <personal-statement v-if="loading" :application-data="applicationData" :application-ref="$route.params.id" />
                </div>


                <div id="funding_details" class="bg-white border border-gray-300 cursor-pointer hover:bg-gray-200 flex justify-between px-8 mt-1"
                     @click="fundingDetailsShow = !fundingDetailsShow"
                >
                    <h1 class="text-1xl leading-10">Funding Details</h1>
                    <icon :name="!fundingDetailsShow ? 'cheveron-right' : 'cheveron-down'"
                          class="fill-current w-7 h-10 ml-2"
                    />
                </div>
                <div id="funding_details_content" :class="{ hide: !fundingDetailsShow }"
                     class="bg-white pb-8 border border-t-0 border-gray-300 overflow-hidden flex flex-wrap"
                >
                    <funding-details v-if="loading" :application-data="applicationData" :scholarships="scholarships" :sponsor-data="sponsorData"
                                     @changeFunding="modeOfFundingChange"
                    />
                </div>


                <div id="documentation" class="bg-white border border-gray-300 cursor-pointer hover:bg-gray-200 flex justify-between px-8 mt-1"
                     @click="documentationShow = !documentationShow"
                >
                    <h1 class="text-1xl leading-10">Supporting Documents</h1>
                    <icon :name="!documentationShow ? 'cheveron-right' : 'cheveron-down'"
                          class="fill-current w-7 h-10 ml-2"
                    />
                </div>
                <div id="documentation_content" :class="{ hide: !documentationShow }"
                     class="bg-white border border-t-0 border-gray-300 overflow-hidden flex flex-wrap"
                >
                    <application-documentation v-if="loading" :application-ref="$route.params.id" :document-types="documentTypes" :documentation="documentation" />
                </div>


                <div id="equal_opportunities" class="bg-white border border-gray-300 cursor-pointer hover:bg-gray-200 flex justify-between px-8 mt-1"
                     @click="equalOpportunitiesShow = !equalOpportunitiesShow"
                >
                    <h1 class="text-1xl leading-10">Equal Opportunities</h1>
                    <icon :name="!equalOpportunitiesShow ? 'cheveron-right' : 'cheveron-down'"
                          class="fill-current w-7 h-10 ml-2"
                    />
                </div>
                <div id="equal_opportunities_content" :class="{ hide: !equalOpportunitiesShow }"
                     class="bg-white border border-t-0 border-gray-300 overflow-hidden flex flex-wrap"
                >
                    <equal-opportunities v-if="loading"
                                         :application-reference="$route.params.id"
                                         :disabilities="disabilities"
                                         :equal-opportunities="equalOpportunities"
                                         :ethnicities="ethnicities"
                                         :gender-identity="genderIdentity"
                                         :religious-belief="religiousBelief"
                                         :sexual-orientation="sexualOrientation"
                                         :sources-of-interest="sourcesOfInterest"
                    />
                </div>

              <div id="contextual_admissions"
                   class="bg-white border border-gray-300 cursor-pointer hover:bg-gray-200 flex justify-between px-8 mt-1 text-left"
                   @click="contextualAdmissionsShow = !contextualAdmissionsShow"
              >
                <h4 class="text-1xl leading-10 text-bold">Contextual Admissions</h4>
                <icon :name="!contextualAdmissionsShow ? 'cheveron-right' : 'cheveron-down'"
                      class="fill-current w-7 h-10 ml-2"
                />
              </div>
              <div :id="`contextual_admissions_content`" :class="{ hide: !contextualAdmissionsShow }" class="m-8 text-left"
              >
                <section-render v-if="loading" :application-id="applicationData.reference" :section="sections.filter((section => section.key === 'contextual-admissions'))[0]" :section-data="applicationData.application_data ?? []"/>
              </div>

                <div id="declaration" class="bg-white border border-gray-300 cursor-pointer hover:bg-gray-200 flex justify-between px-8 mt-1"
                     @click="declarationShow = !declarationShow"
                >
                    <h1 class="text-1xl leading-10">Declaration & Submission</h1>
                    <icon :name="!declarationShow ? 'cheveron-right' : 'cheveron-down'"
                          class="fill-current w-7 h-10 ml-2"
                    />
                </div>
                <div id="declaration_content" :class="{ hide: !declarationShow }" class="bg-white border border-t-0 border-gray-300 overflow-hidden flex flex-wrap">
                    <declaration v-if="loading"
                                 :application-data="applicationData"
                                 :application-reference="$route.params.id"
                                 :contact-data="contactData"
                                 :documentation="documentation"
                                 :employment-history="employmentHistory"
                                 :equal-opportunities="equalOpportunities"
                                 :payment-data="paymentData"
                                 :personal-data="personalData"
                                 :contextual-data="applicationData.application_data['contextual-admissions']"
                                 :prior-education="priorEducation"
                                 :programme-choice="firstChoice"
                                 :programme-choice-type="firstChoiceType"
                                 :programme-data="programmeData.data"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/shared/Icon'
import PersonalDetails from './Details/PersonalDetails'
import Nationality from '@/views/Application/Details/Nationality'
import ContactDetails from './Details/ContactDetails'
import PersonalStatement from './Details/PersonalStatement'
import ProgrammeDetails from './Details/ProgrammeDetails'
import EducationDetails from './Details/EducationDetails'
import EmploymentDetails from './Details/EmploymentDetails'
import FundingDetails from './Details/FundingDetails'
import Referees from './Details/Referees'
import EqualOpportunities from './Details/EqualOpportunities'
import Declaration from './Details/Declaration'
import SectionRender from './Details/SectionRender'
import ApplicationDocumentation from '@/views/Application/Details/ApplicationDocumentation'
import DocumentRequestResponseForm from "@/shared/forms/DocumentRequestResponseForm";
import WorkExperienceAndMathematicsDetails from "@/views/Application/Details/WorkExperienceAndMathematicsDetails.vue";

export default {
    name: 'EditApplication',
    metaInfo() {
        return {
            title: 'Edit Application',
        }
    },
    components: {
        WorkExperienceAndMathematicsDetails,
        DocumentRequestResponseForm,
        Icon,
        PersonalDetails,
        Nationality,
        ContactDetails,
        PersonalStatement,
        ProgrammeDetails,
        EducationDetails,
        EmploymentDetails,
        FundingDetails,
        Referees,
        SectionRender,
        ApplicationDocumentation,
        EqualOpportunities,
        Declaration,
    },
    data() {
        return {
            personalDetailsShow: false,
            nationalityShow: false,
            contactDetailsShow: false,
            statementShow: false,
            programmeDetailsShow: true,
            educationDetailsShow: false,
            employmentDetailsShow: false,
            fundingDetailsShow: false,
            referencesShow: false,
            documentationShow: false,
            equalOpportunitiesShow: false,
            contextualAdmissionsShow: false,
            workExperienceShow: false,
            declarationShow: true,
            applicationData: [],
            personalData: {
                first_name: '',
                last_name: '',
            },
            contactData: [],
            priorEducation: [],
            contextualAdmissions: [],
            employmentHistory: [],
            programmeData: [],
            documentation: [],
            documentTypes: [],
            programmes: [],
            sponsorData: [],
            paymentData: [],
            modeOfFunding: 'Applied',
            loading: false,
            genders: [],
            ethnicities: [],
            disabilities: [],
            equalOpportunities: [],
            religiousBelief: [],
            sexualOrientation: [],
            sourcesOfInterest: [],
            sections: [],
            genderIdentity: [],
            modeOfAttendance: [],
            proposedStartDates: [],
            scholarships: [],
            firstChoiceTypeReference: '',
            firstChoiceReference: '',
            nationality: [],
        }
    },
    computed: {
        firstChoiceType: {
            get: function () {
                const programmeTypes = this.$store.getters.programmeTypesList

                if (programmeTypes !== undefined) {
                    if (this.firstChoiceTypeReference !== undefined && this.firstChoiceTypeReference.length > 0) {
                        return programmeTypes.data.filter(programmeType => programmeType['reference'] === this.firstChoiceTypeReference)[0]
                    } else {
                        if (programmeTypes.data.length > 0 && this.$store.getters.applicationDetails['data']['first_choice_type']) {
                            return programmeTypes.data.filter(programmeType => programmeType['reference'] === this.$store.getters.applicationDetails['data']['first_choice_type'])[0]
                        }
                    }
                }
                return {name: '', num_references_required: 2}
            },
            set: function (newValue) {
                this.firstChoiceTypeReference = newValue
            },
        },
        firstChoice: {
            get: function () {
                const programmes = this.$store.getters.programmesList

                if (programmes !== undefined) {
                    if (this.firstChoiceReference !== undefined && this.firstChoiceReference.length > 0) {
                        return programmes.data.filter(programme => programme['reference'] === this.firstChoiceReference)[0]
                    } else {
                        if (programmes.data.length > 0 && this.$store.getters.applicationDetails['data']['first_choice'] !== null) {
                            return programmes.data.filter(programme => programme['reference'] === this.$store.getters.applicationDetails['data']['first_choice'])[0]
                        }
                    }
                }
                return {name: '', programme_title: '', sits_ipo_ayrc: '', moa_name: ''}
            },
            set: function (newValue) {
                this.firstChoiceReference = newValue
            },
        },
        applicationDetails() {
            return this.$store.getters.applicationDetails
        },
        coursesList() {
            return this.$store.getters.coursesList
        },
        programmesList() {
            return this.$store.getters.programmesList
        },
        gendersList() {
            return this.$store.getters.gendersList
        },
        titlesList() {
            return this.$store.getters.titlesList
        },
        sections() {
          return this.$store.getters.sections
        },
        ethnicityList() {
            return this.$store.getters.ethnicityList
        },
        disabilityList() {
            return this.$store.getters.disabilityList
        },
        religiousBeliefList() {
            return this.$store.getters.religiousBeliefList
        },
        sexualOrientationList() {
            return this.$store.getters.sexualOrientationList
        },
        genderIdentityList() {
            return this.$store.getters.genderIdentityList
        },
        documentTypesList() {
            return this.$store.getters.documentTypesList
        },
        sourcesOfInterestList() {
            return this.$store.getters.sourcesOfInterestList
        },
        contactDetailTypesList() {
            return this.$store.getters.contactDetailTypesList
        },
        countriesOfDomicileList() {
            return this.$store.getters.countriesOfDomicileList
        },
        countriesOfBirthList() {
            return this.$store.getters.countriesOfBirthList
        },
        programmeTypesList() {
            return this.$store.getters.programmeTypesList
        },
        modeOfAttendanceList() {
            return this.$store.getters.modeOfAttendanceList
        },
        proposedStartDateList() {
            return this.$store.getters.proposedStartDateList
        },
        scholarshipsList() {
            return this.$store.getters.scholarshipsList
        },
        nationalityList() {
            return this.$store.getters.nationalityList
        },
        requireWorkExperienceOrMaths() {
            if (this.programmeData === undefined || this.programmeData === null || this.programmeData.data === undefined || this.programmeData.data === null)
                return false;

            let filtered = this.programmeData.data.filter(programme => programme.requireWorkExperience || programme.requireMathsSkills);
            return filtered !== undefined && filtered !== null && filtered.length > 0;
        }
    },
    watch: {
        applicationDetails(data) {
            this.applicationData = data.data
            this.personalData = data.data.user.data
            this.contactData = data.data.contactDetails.data
            this.programmeData = data.data.applicationProgrammes
            this.priorEducation = data.data.priorEducation.data
            this.employmentHistory = data.data.employmentHistory.data
            this.equalOpportunities = data.data.equalOpportunities.data
            this.documentation = data.data.documents.data
            this.documentTypes = data.data.documentTypes
            this.sponsorData = data.data.applicationSponsors.data
            this.paymentData = data.data.payments.data
            this.loading = true

            if (this.applicationData['status'] !== 'Draft') {
                window.location.href = '/applications/' + this.applicationData['reference'] + '/Review'
            }

        },
        programmesList(data) {
            this.programmes = data
        },
        coursesList(data) {
            this.courses = data
        },
        gendersList(data) {
            this.genders = data
        },
        ethnicityList(data) {
            this.ethnicities = data
        },
        disabilityList(data) {
            this.disabilities = data
        },
        religiousBeliefList(data) {
            this.religiousBelief = data
        },
        sexualOrientationList(data) {
            this.sexualOrientation = data
        },
        genderIdentityList(data) {
            this.genderIdentity = data
        },
        documentTypesList(data) {
            this.documentTypes = data
        },
        sourcesOfInterestList(data) {
            this.sourcesOfInterest = data
        },
        modeOfAttendanceList(data) {
            this.modeOfAttendance = data
        },
        proposedStartDateList(data) {
            this.proposedStartDates = data
        },
        scholarshipsList(data) {
            this.scholarships = data
        },
        nationalityList(data) {
            this.nationality = data
        },
    },
    mounted() {
    },
    created() {
        this.loadApplication()

        // pass parameter in url to expand that section on load (eg section=educationDetailsShow). then remove the param
        const expandSection = new URLSearchParams(window.location.search).get('section')
        this[expandSection] = true

        const url = new URL(location)
        url.searchParams.delete('section')
        history.replaceState(null, null, url)
    },
    methods: {
        loadApplication() {
            this.$store.dispatch('retrieveSingleApplication', {
                applicationRef: this.$route.params.id,
            })
        },
        programmeTypeChange(newValue) {
            this.firstChoiceType = newValue
        },
        programmeChange(newValue) {
            this.firstChoice = newValue
        },
        modeOfFundingChange(value) {
            this.modeOfFunding = value
        },
    },
}
</script>
<style scoped>
.hide {
    display: none !important;
}
</style>